export function warn(msg) {
  console.warn(msg);
}

export function info(msg) {
  console.log(msg);
}
